/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-misused-promises */
import http from 'hub-http/clients/apiClient';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { getFullUrl } from 'hubspot-url-utils';
import Raven from 'raven-js';
import { getIsQAProxy } from '../utils/proxyUtils';
import { getSeatsCountryCode } from '../utils/seatsUtils';
const PUBLIC_ENDPOINT = 'monetization/v3/product/bundle/public';
const IN_APP_ENDPOINT = 'monetization/v3/product/bundle/in-app';
export const getProductBundles = apiNames => {
  const url = `${getFullUrl('app-api', getIsQAProxy() ? {
    envOverride: 'qa'
  } : {})}/${IN_APP_ENDPOINT}`;
  return http.get(url, {
    query: {
      productApiNames: apiNames
    }
  }).catch(err => {
    Raven.captureException(new Error('Failed to fetch product bundles'), {
      extra: {
        err,
        apiNames
      }
    });
    throw err;
  });
};
export const getPublicProductBundles = apiNames => {
  const countryCode = getSeatsCountryCode() || window.COUNTRY_CODE_FROM_LOCALE && window.COUNTRY_CODE_FROM_LOCALE.toUpperCase();
  const url = `${getFullUrl('app-api', getIsQAProxy() ? {
    envOverride: 'qa'
  } : {})}/${PUBLIC_ENDPOINT}?countryCode=${countryCode}`;
  return noAuthHttp.get(url, {
    query: {
      productApiNames: apiNames
    }
  }).catch(err => {
    Raven.captureException(new Error('Failed to fetch public product bundles'), {
      extra: {
        err,
        apiNames
      }
    });
    throw err;
  });
};